import React, { Component } from 'react'
import urljoin from 'url-join'
import Card from '../Card'
import config from '../../../data/SiteConfig'
import * as DisqusR from 'disqus-react'

class Disqus extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toasts: [],
    }
    this.notifyAboutComment = this.notifyAboutComment.bind(this)
    this.onSnackbarDismiss = this.onSnackbarDismiss.bind(this)
  }

  onSnackbarDismiss() {
    const [, ...toasts] = this.state.toasts
    this.setState({ toasts })
  }
  notifyAboutComment() {
    const toasts = this.state.toasts.slice()
    toasts.push({ text: 'New comment available!' })
    this.setState({ toasts })
  }
  render() {
    const { postNode, expanded } = this.props
    if (!config.disqusShortname) {
      return null
    }

    const disqusShortname = config.disqusShortname
    const disqusConfig = {
      url: 'http://activelamp.com' + postNode.frontmatter.id,
      title: postNode.frontmatter.title,
    }

    return (
      <Card>
        <div className="disqus-container">
          <DisqusR.DiscussionEmbed
            shortname={disqusShortname}
            config={disqusConfig}
          />
        </div>
      </Card>
    )
  }
}

export default Disqus
